let theme = { dark: {}, light: {} };

export const getInitialTheme = () => theme;
export const initializeTheme = (themeEntries) => {
  if (typeof themeEntries === "object" && themeEntries.light && themeEntries.dark) {
    theme = themeEntries;
  }
};
